// import React from "react";

// const InfoTitle = () => {
//   return <div>InfoTitle</div>;
// };

// export default InfoTitle;

import React from "react";

const InfoTitle = ({
  title = "Title",
  color = "black", // primary, success, error, warning, info, black, white
  colorDepth = 500, // 50..900
  icon = "",
  iconPosition = "before", // before, after
  tag = "h4",
  className = "", //header-1,header-2,header-3,header-4,header-5,header-6
}) => {
  const Tag = tag; // ✅ Dynamic tag name

  const textColor =
    color === "black" || color === "white"
      ? color
      : `text-${color}-${colorDepth}`;

  // Merge user's toolTip props with defaults
  // Import defaultToolTip from Constants.js

  const headerElement = (
    <div className={`flex items-center gap-2 ${textColor}`}>
      {iconPosition === "before" && icon !== "" && (
        <span class="material-symbols-outlined">{icon}</span>
      )}
      <Tag className={className}>{title}</Tag>
      {iconPosition === "after" && icon !== "" && (
        <span class="material-symbols-outlined">{icon}</span>
      )}
    </div>
  );

  return <div>{headerElement}</div>;
};

export default InfoTitle;
